import React from 'react'

import { Tooltip } from '@sketch/components'
import { StyledLeftArrow, StyledButton } from './BackButton.styles'
import { useBackButton } from './useBackButton'

type BackButtonLinkProps = {
  /** What the tooltip says this goes back to. */
  content: string
  link: string
  className?: string
}

/**
 * The arrow on its own, for a view that already knows where back is.
 *
 * The contextual button below only appears when the navigation stack says
 * where the user came from. A view with a fixed way out - an embedded Section,
 * whose only route onwards is the document - says so itself, and still draws
 * the same button at the same size.
 */
export function BackButtonLink({
  content,
  link,
  className,
}: BackButtonLinkProps) {
  return (
    <Tooltip content={content} placement="bottom">
      <StyledButton to={link} className={className} data-testid="back-button">
        <StyledLeftArrow />
      </StyledButton>
    </Tooltip>
  )
}

type BackButtonProps = {
  className?: string
}

/**
 * Contextual back button for the shares related views so that
 * the user can quickly come back to the previous view they are
 * coming from.
 */
export default function BackButton({ className }: BackButtonProps) {
  const { content, link } = useBackButton()

  if (!link) {
    return null
  }

  return <BackButtonLink content={content} link={link} className={className} />
}
